"use client";
import { StaticImageData } from "next/image";
import Image from "next/image";
import ActionCircleButton from "../shared/ActionCircleButton";
import { useState } from "react";
import { cn } from "@/lib/utils/utils";

interface CaseStudyImageProps {
  imgSrc: string | StaticImageData;
  slug?: string;
  href?: string;
  title: string;
  className?: string;
  wrapperClass?: string;
  imageClassName?: string;
  children?: React.ReactNode;
}

const CaseStudyImageHover = ({
  imgSrc,
  slug,
  title,
  href,
  className,
  wrapperClass,
  imageClassName,
  children,
}: CaseStudyImageProps) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div
      className={cn(
        "relative overflow-hidden cursor-pointer",
        className ||
          "w-full md:w-[55%] lg:w-[41%] flex items-center justify-end",
      )}
      // Desktop Hover
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      // Mobile Touch Support
      onTouchStart={() => setIsHovered(true)}
    >
      <div
        className={cn(
          "relative w-full overflow-hidden",
          wrapperClass ||
            "h-87.5 md:h-[64vh] lg:h-auto lg:aspect-square rounded-2xl",
        )}
      >
        <Image
          src={imgSrc}
          alt={`${title} — Octarnal project`}
          fill
          sizes="(max-width: 768px) 100vw, 50vw"
          // Zooming scale transition added. imageClassName wins via twMerge, so a
          // caller can swap object-cover → object-contain to show the full image.
          className={cn(
            "object-cover object-left lg:object-right aspect-square transition-transform duration-700 ease-out",
            isHovered ? "scale-105" : "scale-100",
            imageClassName,
          )}
        />
        {/* Always mounted so its <Link> is in the server HTML — this is the only
            link from a service detail page to its case studies. It used to be
            {isHovered && ...}, which meant those pages shipped zero outbound
            links and read as dead ends to crawlers. Visual behaviour is
            unchanged: it still fades/scales in on hover only. */}
        <ActionCircleButton
          text="Case Study"
          slug={slug}
          href={href}
          isVisible={isHovered}
          className="lg:w-40 lg:h-40 w-28 h-28 bg-white/40 backdrop-blur-md"
        />
        {/*  Title Overlay Card for Service details */}
        {children}
      </div>
    </div>
  );
};

export default CaseStudyImageHover;
